import { render, staticRenderFns } from "./UploadEvidence.vue?vue&type=template&id=1f922d58&scoped=true&lang=pug&"
import script from "./UploadEvidence.vue?vue&type=script&lang=js&"
export * from "./UploadEvidence.vue?vue&type=script&lang=js&"
import style0 from "./UploadEvidence.vue?vue&type=style&index=0&id=1f922d58&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f922d58",
  null
  
)

export default component.exports